/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const DetailWholesaleMenuPage = lazyLoad(
  () => import('./index'),
  module => module.DetailWholesaleMenuPage
);
